import React, { FC } from "react"
import { StatisticsCard } from "../StatisticsCard"
import {
  ChartPieIcon,
  CubeIcon,
  PuzzlePieceIcon,
  ClockIcon,
  TruckIcon,
  BookOpenIcon,
} from "@heroicons/react/24/outline"
import { Statistic } from "@/lib/types"
import { useRouter } from "next/router"

type Props = {
  listingData: Statistic
}

export const Statistics: FC<Props> = (props) => {
  const router = useRouter()
  return (
    <div>
      <div className="grid 2xl:grid-cols-3 sm:grid-cols-2 grid-cols-1 2xl:gap-7 gap-5 statistics-sec">
        <StatisticsCard
          title="Total Quotes"
          icon={<ChartPieIcon />}
          icon_color="text-[#B89061]"
          number={props.listingData.statistics.totalQuotes}
          percent={props.listingData.statistics.totalQuotesPercentage}
          p_color="text-accent"
        />
        <StatisticsCard
          title="Total Booked"
          icon={<CubeIcon />}
          icon_color="text-[#0B6391]"
          number={props.listingData.statistics.totalBooked}
          percent={props.listingData.statistics.totalBookedPercentage}
          p_color="text-[#076FA4]"
        />
        <StatisticsCard
          title="New Customers"
          icon={<PuzzlePieceIcon />}
          icon_color="text-[#9A3FF4]"
          number={props.listingData.statistics.newCustomers}
          percent={props.listingData.statistics.newCustomersPercentage}
          p_color="text-[#076FA4]"
        />
        <StatisticsCard
          title="Avg Daily Quotes"
          icon={<ClockIcon />}
          icon_color="text-[#8C3BDD]"
          number={props.listingData.statistics.avgQuotesPerDay}
          percent={props.listingData.statistics.avgQuotesPerDayPercentage}
          p_color="text-[#7936BE]"
        />
        <StatisticsCard
          title="Average Daily Booked"
          icon={<TruckIcon />}
          icon_color="text-[#07A45B]"
          number={props.listingData.statistics.avgBookedPerDay}
          percent={props.listingData.statistics.avgBookedPerDayPercentage}
          p_color="text-[#0B844D]"
        />
        <div
          className="cursor-pointer"
          onClick={() => router.push("/quote-errors?pageNum=1&input=")}
        >
          <StatisticsCard
            title="Error"
            icon={<BookOpenIcon />}
            icon_color="text-[#F12E51]"
            number={props.listingData.statistics.totalerrors}
            percent={props.listingData.statistics.errorsPercentage}
            p_color="text-[#DE2D4D]"
          />
        </div>
      </div>
    </div>
  )
}
